import global from 'Global';

function ImageService() {
}

/*! SuppressStringValidation String validation suppressed in initial refactor */
ImageService.prototype.getImageUri = (id) => `${global.serviceUri}api/media/images/${id}`;

export default new ImageService();
